export default __webpack_public_path__ + "static/media/kitchenHelper.3435d6db.svg";